import { cn } from "@/lib/cn";

const PALETTE = [
	"#C6563A",
	"#1E4D3B",
	"#D4A24C",
	"#A04428",
	"#3A6A8C",
	"#8F3B26",
	"#2B6A8E",
];

function adminAvColor(s: string): string {
	let h = 0;
	for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) & 0xffff;
	return PALETTE[h % PALETTE.length];
}

interface AdminAvatarProps {
	name: string;
	size?: "sm" | "md" | "lg";
	className?: string;
}

export function AdminAvatar({
	name,
	size = "sm",
	className,
}: AdminAvatarProps) {
	const initials = name
		.split(" ")
		.map((w) => w[0])
		.slice(0, 2)
		.join("")
		.toUpperCase();
	return (
		<span
			className={cn(
				"av",
				size === "lg" && "lg",
				size === "sm" && "sm",
				className,
			)}
			style={{ background: adminAvColor(name) }}
		>
			{initials}
		</span>
	);
}
